import type { ApolloClient } from '@apollo/client'
import currencyJs from 'currency.js'

export const updateItemQuantityCache = (
    client: ApolloClient<object>,
    id: string,
    quantityChange: number
): void => {
    client.cache.modify({
        id: client.cache.identify({ __typename: 'CartItem', uuid: id }),
        fields: {
            totalProductPrice: (existing, { readField }) => {
                const currentQuantity = readField<number>('quantity')
                const currentAmount = readField<string>('amount', existing)

                if (!currentQuantity || currentAmount === undefined) return existing

                return {
                    ...existing,
                    amount: currencyJs(currentAmount)
                        .divide(currentQuantity)
                        .multiply(currentQuantity + quantityChange)
                        .toString(),
                }
            },
            quantity: (existing) => existing + quantityChange,
        },
    })
}
